"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
require("@gaming/mtt-postal.federation");
require("@gaming/mtt-postal.xframe");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_mttPostal.default.configuration.DEFAULT_CHANNEL = "mtt.client";
_mttPostal.default.fedx.configure({
  filterMode: "whitelist"
});
_mttPostal.default.fedx.addFilter([{
  channel: "mtt.client",
  topic: "#",
  direction: "both"
}]);
var _default = _mttPostal.default;
exports.default = _default;